import React from 'react';
import NuevaReceta from './NuevaReceta';

/**
 * Wrapper para editar recetas existentes
 * Ahora usa el componente moderno NuevaReceta
 */
function EditarRecetaWrapper() {
  return <NuevaReceta />;
}

export default EditarRecetaWrapper;